import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../../../components/form/CheckboxInput'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import useHandleGroupedConfigChange from '../_helpers/useHandleGroupConfigChange'

const AnnotationSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const handleGroupedConfigChange = useHandleGroupedConfigChange()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderAnnotation = shouldRender('notes')

  if (!shouldRenderAnnotation) return false

  return (
    <>
      <Title size="h6" color={COLORS.dark4}>
        {t('annotations')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <CheckboxInput
        label={t('allowAnnotations')}
        value={selectedQuestion.notesEnabled}
        onChange={handleGroupedConfigChange('notesEnabled')}
      />

      <CheckboxInput
        label={t('requiredAnnotations')}
        value={selectedQuestion.notesRequired}
        onChange={handleSelectedQuestionChange('notesRequired')}
        disabled={!selectedQuestion.notesEnabled}
      />
    </>
  )
}

export default AnnotationSection
